"use strict";

import Vue from 'vue';
import axios from 'axios';
//import util from '../common/util.js';
//import router from '../router.js';

// 设置默认表单数据格式
// var qs = require('qs'); // ES5
// 或者ES6: import qs from 'qs';
// axios.defaults.transformRequest = [function(data) {
//     return qs.stringify(data)
// }];
// 或者使用箭头函数
// axios.defaults.transformRequest = [data => qs.stringify(data)];

// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

// 重复请求合并：连续发起的重复请求, 仅请求一次, 并将请求结果分别返回给不同的发起者
// method+url+params+data+hash相同视为重复请求，上传接口除外
// 手动允许重复请求的设置repeatable: true

let config = {
    // baseURL: process.env.baseURL || process.env.apiUrl || ""
    baseURL: location.protocol + '//' + location.host,
    // handleErrorsYourself: false,
    // handleStatusCodeYourself: false,
    // baseURL: 'http://10.1.10.51:3000',
    timeout: 60 * 1000, // Timeout
    // withCredentials: true, // Check cross-site Access-Control
};

const _axios = axios.create(config);

// 发布订阅
class EventEmitter {
    constructor() {
        this.event = {};
    }
    on(type, cbres, cbrej) {
        if (!this.event[type]) {
            this.event[type] = [[cbres, cbrej]];
        } else {
            this.event[type].push([cbres, cbrej]);
        }
    }

    emit(type, res, ansType) {
        if (!this.event[type]) {
            return;
        } else {
            this.event[type].forEach(cbArr => {
                let json = null;
                try {
                    json = JSON.parse(JSON.stringify(res));
                } catch(e) {
                    json = res;
                }
                if(ansType === 'resolve') {
                    cbArr[0](json);
                } else {
                    cbArr[1](json);
                }
            });
        }
    }
}

// 根据请求生成对应的key
function generateReqKey(config, hash) {
    const { method, url, params, data } = config;
    return [method, url, JSON.stringify(params), JSON.stringify(data), hash].join('&');
}
// 文件上传，直接放行
function isFileUploadApi(config) {
    return Object.prototype.toString.call(config.data) === "[object FormData]";
}

// 存储已发送但未响应的请求
const pendingRequest = new Set();
// 发布订阅容器
const ev = new EventEmitter();

_axios.interceptors.request.use(
    async function (configParam) {
        // Do something before request is sent
        let hash = location.hash;
        // 生成请求Key
        let reqKey = generateReqKey(configParam, hash);

        if(!isFileUploadApi(configParam) && !configParam.repeatable) {
            if (pendingRequest.has(reqKey)) {
                // 如果是相同请求,在这里将请求挂起，通过发布订阅来为该请求返回结果
                // 这里需注意，拿到结果后，无论成功与否，都需要return Promise.reject()来中断这次请求，否则请求会正常发送至服务器
                let res = null;
                try {
                    // 接口成功响应
                    res = await new Promise((resolve, reject) => {
                        ev.on(reqKey, resolve, reject);
                    });
                    return Promise.reject({
                        type: 'limiteResSuccess',
                        val: res
                    });
                } catch (limitFunErr) {
                    // 接口报错
                    return Promise.reject({
                        type: 'limiteResError',
                        val: limitFunErr
                    });
                }
            } else {
                // 将请求的key保存在config
                configParam.pendKey = reqKey;
                pendingRequest.add(reqKey);
            }
        }

        // config.handleErrorsYourself = configParam.handleErrorsYourself || false;
        // config.handleStatusCodeYourself = configParam.handleStatusCodeYourself || false;
        return configParam;
    },
    function (error) {
        // Do something with request error
        return Promise.reject(error);
    }
);

// Add a response interceptor
_axios.interceptors.response.use(
    function (response) {
        // console.log('response', response);
        // 将拿到的结果发布给其他相同的接口
        handleSuccessResponse_limit(response);
        // Do something with response data
        let json = response.data || {};
        if (json.statusCode == 'LOGIN_NOT_NORMAL') {
            //console.log('登录态失效');
            //window.$jsbridge.post('popUntil', {router: 'login'}, null);
            Vue.$message.error({
                message: '登录态已失效...请重新登录',
                showClose: true,
                onClose: function() {
                    //Vue.$jsbridge.post('logout', null, null);
                    //Vue.$jsbridge.post('pushNamedAndRemoveUntil', {router: 'login', removeUntil: 'main_page'}, null);
                    //Vue.$jsbridge.post('pushNamed', {router: 'login'}, null);
                }
            });
            Vue.$jsbridge.post('logout', null, null);
        } else if(!(response.config||{}).handleStatusCodeYourself&&json.statusCode&&json.statusCode != '0' && json.statusCode != 'NEED_CONFIRM') {
            Vue.$message.error({
                message: json.statusDesc,
                supportHTML: true,
                showClose: true
            });
        }
        //console.log(response)
        return json;
    },
    function (error) {
        return handleErrorResponse_limit(error);
    }
);

// 接口响应成功
function handleSuccessResponse_limit(response) {
    const reqKey = response.config.pendKey;
    if (reqKey && pendingRequest.has(reqKey)) {
        // let json = null;
        // try {
        //     json = JSON.parse(JSON.stringify(response));
        // } catch(e) {
        //     json = response;
        // }
        pendingRequest.delete(reqKey);
        ev.emit(reqKey, response, 'resolve');
        delete ev.event[reqKey];
        // setTimeout(() => {
        //     pendingRequest.delete(reqKey);
        //     delete ev.event[reqKey];
        // }, 200);
    }
}

// 接口走失败响应
function handleErrorResponse_limit(error) {
    if (error.type && error.type === 'limiteResSuccess') {
        let response = error.val;
        let res = response.data || {};
        if(res.statusCode == 'NEED_CONFIRM') {
            res.statusCode = '1';
            res.statusDesc = '操作重复';
        }
        if(!(response.config||{}).handleStatusCodeYourself&&res.statusCode&&res.statusCode != '0') {
            Vue.$message.error({
                message: res.statusDesc,
                supportHTML: true,
                showClose: true
            });
        }
        return Promise.resolve(res);
    } else if (error.type && error.type === 'limiteResError') {
        console.log('limiteResError: ', error.val);
        return Promise.reject(error.val);
    } else {
        console.log('error: ', error);
        const reqKey = error.config.pendKey;
        if(reqKey && pendingRequest.has(reqKey)) {
            // let json = null;
            // try {
            //     json = JSON.parse(JSON.stringify(error));
            // } catch(e) {
            //     json = error;
            // }
            pendingRequest.delete(reqKey);
            ev.emit(reqKey, error, 'reject');
            delete ev.event[reqKey];
        }
    }
    // Do something with response error
    if (error && error.response) {
        switch (error.response.status) {
            case 400:
                error.message = '错误请求';
                break;
            case 401:
                //util.cookie.set('token', '', '', '', -1);
                Vue.$util.cookie.clear();
                error.message = '未授权，请重新登录';
                setTimeout(() => {
                    Vue.$jsbridge.post('logout', null, null);
                }, 0);
                if(location.hash.indexOf('temporaryWorker')!=-1){
                    location.hash='#/temporaryWorker-login'
                }
                break;
            case 403:
                error.message = '拒绝访问';
                break;
            case 404:
                error.message = '请求错误,未找到该资源';
                break;
            case 405:
                error.message = '请求方法未允许';
                break;
            case 408:
                error.message = '请求超时';
                break;
            case 500:
                error.message = '服务器端出错';
                break;
            case 501:
                error.message = '网络未实现';
                break;
            case 502:
                error.message = '网络错误';
                break;
            case 503:
                error.message = '服务不可用';
                break;
            case 504:
                error.message = '网络超时';
                break;
            case 505:
                error.message = 'http版本不支持该请求';
                break;
            default:
                error.message = `连接错误${error.response.status}`;
        }
    } else {
        if(!error) {
            error = {};
        }
        error.message = '连接到服务器失败';
    }
    //Vue.$jsbridge.call('showAlert', {message: error.message}, null);
    if(!(error.config||{}).handleErrorsYourself) {
        Vue.$message.error({
            message: error.message,
            //duration: 7000,
            supportHTML: true,
            showClose: true
        });
    }
    return Promise.reject(error);
}

Plugin.install = function (Vue) {
    Vue.axios = _axios;
    window.axios = _axios;
    Object.defineProperties(Vue.prototype, {
        axios: {
            get() {
                return _axios;
            }
        },
        $axios: {
            get() {
                return _axios;
            }
        },
        gaxios: {//调用静态方法用这个
            get() {
                return axios;
            }
        }
    });
};

Vue.use(Plugin);

export default Plugin;
